<template>
    <swiper
      :modules="modules"
      :slides-per-view="1"
      :space-between="30"
      :breakpoints="{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 }
      }"
      :loop="true"
      :autoplay="{ delay: 6000, disableOnInteraction: false }"
      :pagination="{ clickable: true, el: '.custom-pagination' }"
      class="relative z-10"
    >
        <swiper-slide v-for="(commentaire, index) in commentaires" :key="index">
            <div class="bg-white rounded-xl shadow-lg p-6 h-full flex flex-col transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
                <div class="flex items-center mb-4">
                    <div class="flex space-x-1 text-yellow-400">
                        <i class="fas fa-star" v-for="n in commentaire.rating" :key="n"></i>
                    </div>
                </div>
                
                <div class="relative mb-6">
                    <p class="text-gray-600 italic relative z-10">
                        "{{ commentaire.content }}"
                    </p>
                </div>
                
                <div class="mt-auto flex items-center">
                    <div class="w-12 h-12 rounded-full overflow-hidden border-2 border-white shadow-md bg-gray-100 flex items-center justify-center">
                        <i :class="commentaire.icone" class="text-gray-400 text-xl" v-if="!commentaire.image"></i>
                        <img :src="commentaire.image" alt="" class="w-full h-full object-cover" v-else>
                    </div>
                    <div class="ml-4">
                        <h3 class="font-bold text-gray-800">{{ commentaire.nom }}</h3>
                        <p class="text-sm text-gray-500">{{ commentaire.poste }}</p>
                    </div>
                </div>
            </div>
        </swiper-slide>
    </swiper>

    <!-- Pagination personnalisée -->
    <div class="custom-pagination flex justify-center mt-8 space-x-2"></div>
</template>

<script>
import { Pagination, A11y, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
        commentaires: [
            {
                icone: 'fab fa-facebook',
                nom: 'Marie Dubois',
                poste: 'Client iPhone 13 Pro',
                content: 'Livraison ultra rapide et téléphone en parfait état. L\'emballage était soigné et le prix imbattable. Je recommande vivement !',
                image: './img/icone.png',
                rating: 5,
                color: '#3b5998'
            },
            {
                icone: 'fab fa-google',
                nom: 'Thomas Martin',
                poste: 'Client Android S22',
                content: 'Excellent rapport qualité-prix. Le téléphone était neuf sous blister comme promis. Service client réactif pour mes questions.',
                image: './img/icone.png',
                rating: 4,
                color: '#DB4437'
            },
            {
                icone: 'fab fa-twitter',
                nom: 'Sophie Lambert',
                poste: 'Client AirPods Pro',
                content: 'Les écouteurs sont authentiques et fonctionnent parfaitement. Livraison express et suivi de colis très professionnel.',
                image: './img/icone.png',
                rating: 5,
                color: '#1DA1F2'
            },
            {
                icone: 'fab fa-instagram',
                nom: 'Alexandre Petit',
                poste: 'Client iPhone 12',
                content: 'Un peu sceptique au début mais finalement très satisfait. Le téléphone est comme neuf et la batterie tient bien. Merci !',
                image: './img/icone.png',
                rating: 4,
                color: '#E1306C'
            },
            {
                icone: 'fas fa-globe',
                nom: 'Camille Leroy',
                poste: 'Client Galaxy Watch',
                content: 'Montre livrée avec tous les accessoires. Prix bien en dessous du marché pour un produit neuf. Je reviendrai !',
                image: './img/icone.png',
                rating: 5,
                color: '#6f42c1'
            }
        ],
    };
  },
  computed: {
    shouldLoop() {
      // Active le loop seulement si on a assez de slides (au moins le double de slidesPerView)
      return this.commentaires.length >= 6; // Pour slidesPerView=3, il faut au moins 6 slides pour un bon loop
    }
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, A11y],
    };
  },
};
</script>

<style scoped>
.custom-pagination {
  position: relative;
  bottom: 0;
  z-index: 20;
}

.custom-pagination :deep(.swiper-pagination-bullet) {
  width: 12px;
  height: 12px;
  background-color: #ddd;
  opacity: 1;
  margin: 0 5px;
  transition: all 0.3s;
}

.custom-pagination :deep(.swiper-pagination-bullet-active) {
  background: linear-gradient(to right, #f97316, #ea580c);
  transform: scale(1.2);
}
</style>